"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var compose_exports = {};
__export(compose_exports, {
  Compose: () => Compose
});
module.exports = __toCommonJS(compose_exports);
function unsupported(name) {
  throw new Error(`Compose.${name} requires an Android native build`);
}
function Column(_props) {
  return unsupported("Column");
}
function Row(_props) {
  return unsupported("Row");
}
function Spacer(_props) {
  return unsupported("Spacer");
}
function FlowRow(_props) {
  return unsupported("FlowRow");
}
function Box(_props) {
  return unsupported("Box");
}
function Badge(_props) {
  return unsupported("Badge");
}
function BadgedBoxRoot(_props) {
  return unsupported("BadgedBox");
}
var BadgedBox = Object.assign(BadgedBoxRoot, {
  Badge: function Badge2(_props) {
    return unsupported("BadgedBox.Badge");
  }
});
function ListItemRoot(_props) {
  return unsupported("ListItem");
}
var ListItem = Object.assign(ListItemRoot, {
  HeadlineContent: function HeadlineContent(_props) {
    return unsupported("ListItem.HeadlineContent");
  },
  OverlineContent: function OverlineContent(_props) {
    return unsupported("ListItem.OverlineContent");
  },
  SupportingContent: function SupportingContent(_props) {
    return unsupported("ListItem.SupportingContent");
  },
  LeadingContent: function LeadingContent(_props) {
    return unsupported("ListItem.LeadingContent");
  },
  TrailingContent: function TrailingContent(_props) {
    return unsupported("ListItem.TrailingContent");
  }
});
function Card(_props) {
  return unsupported("Card");
}
function ElevatedCard(_props) {
  return unsupported("ElevatedCard");
}
function OutlinedCard(_props) {
  return unsupported("OutlinedCard");
}
function Surface(_props) {
  return unsupported("Surface");
}
function HorizontalDivider(_props) {
  return unsupported("HorizontalDivider");
}
function VerticalDivider(_props) {
  return unsupported("VerticalDivider");
}
function FilterChipRoot(_props) {
  return unsupported("FilterChip");
}
function AssistChipRoot(_props) {
  return unsupported("AssistChip");
}
function InputChipRoot(_props) {
  return unsupported("InputChip");
}
function SuggestionChipRoot(_props) {
  return unsupported("SuggestionChip");
}
var ChipLabel = function ChipLabel2(_props) {
  return unsupported("Chip.Label");
};
var ChipLeadingIcon = function ChipLeadingIcon2(_props) {
  return unsupported("Chip.LeadingIcon");
};
var ChipTrailingIcon = function ChipTrailingIcon2(_props) {
  return unsupported("Chip.TrailingIcon");
};
var ChipAvatar = function ChipAvatar2(_props) {
  return unsupported("Chip.Avatar");
};
var ChipIcon = function ChipIcon2(_props) {
  return unsupported("Chip.Icon");
};
var AssistChip = Object.assign(AssistChipRoot, {
  Label: ChipLabel,
  LeadingIcon: ChipLeadingIcon,
  TrailingIcon: ChipTrailingIcon
});
var FilterChip = Object.assign(FilterChipRoot, {
  Label: ChipLabel,
  LeadingIcon: ChipLeadingIcon,
  TrailingIcon: ChipTrailingIcon
});
var InputChip = Object.assign(InputChipRoot, {
  Label: ChipLabel,
  Avatar: ChipAvatar,
  TrailingIcon: ChipTrailingIcon
});
var SuggestionChip = Object.assign(SuggestionChipRoot, {
  Label: ChipLabel,
  Icon: ChipIcon
});
function Text(_props) {
  return unsupported("Text");
}
function Icon(_props) {
  return unsupported("Icon");
}
function Button(_props) {
  return unsupported("Button");
}
function IconButton(_props) {
  return unsupported("IconButton");
}
function FilledIconButton(_props) {
  return unsupported("FilledIconButton");
}
function FilledTonalIconButton(_props) {
  return unsupported("FilledTonalIconButton");
}
function OutlinedIconButton(_props) {
  return unsupported("OutlinedIconButton");
}
var FloatingActionButton = Object.assign(function(_props) {
  return unsupported("FloatingActionButton");
}, {
  Icon: function Icon2(_props) {
    return unsupported("FloatingActionButton.Icon");
  }
});
var SmallFloatingActionButton = Object.assign(function(_props) {
  return unsupported("SmallFloatingActionButton");
}, {
  Icon: function Icon3(_props) {
    return unsupported("SmallFloatingActionButton.Icon");
  }
});
var LargeFloatingActionButton = Object.assign(function(_props) {
  return unsupported("LargeFloatingActionButton");
}, {
  Icon: function Icon4(_props) {
    return unsupported("LargeFloatingActionButton.Icon");
  }
});
var ExtendedFloatingActionButton = Object.assign(function(_props) {
  return unsupported("ExtendedFloatingActionButton");
}, {
  Icon: function Icon5(_props) {
    return unsupported("ExtendedFloatingActionButton.Icon");
  },
  Text: function Text2(_props) {
    return unsupported("ExtendedFloatingActionButton.Text");
  }
});
function ToggleButton(_props) {
  return unsupported("ToggleButton");
}
function IconToggleButton(_props) {
  return unsupported("IconToggleButton");
}
function FilledIconToggleButton(_props) {
  return unsupported("FilledIconToggleButton");
}
function OutlinedIconToggleButton(_props) {
  return unsupported("OutlinedIconToggleButton");
}
function SingleChoiceSegmentedButtonRow(_props) {
  return unsupported("SingleChoiceSegmentedButtonRow");
}
function MultiChoiceSegmentedButtonRow(_props) {
  return unsupported("MultiChoiceSegmentedButtonRow");
}
function SegmentedButton(_props) {
  return unsupported("SegmentedButton");
}
function Switch(_props) {
  return unsupported("Switch");
}
function Checkbox(_props) {
  return unsupported("Checkbox");
}
function RadioButton(_props) {
  return unsupported("RadioButton");
}
function TextField(_props) {
  return unsupported("TextField");
}
function Slider(_props) {
  return unsupported("Slider");
}
function AlertDialog(_props) {
  return unsupported("AlertDialog");
}
function Dialog(_props) {
  return unsupported("Dialog");
}
function LazyColumn(_props) {
  return unsupported("LazyColumn");
}
function LazyRow(_props) {
  return unsupported("LazyRow");
}
function Image(_props) {
  return unsupported("Image");
}
function Snackbar(_props) {
  return unsupported("Snackbar");
}
function SnackbarHost(_props) {
  return unsupported("SnackbarHost");
}
var ModalBottomSheetRoot = function ModalBottomSheetRoot2(_props) {
  return unsupported("ModalBottomSheet");
};
var ModalBottomSheet = Object.assign(ModalBottomSheetRoot, {
  DragHandle: function DragHandle(_props) {
    return unsupported("ModalBottomSheet.DragHandle");
  }
});
function NavigationBar(_props) {
  return unsupported("NavigationBar");
}
function NavigationBarItem(_props) {
  return unsupported("NavigationBarItem");
}
var SearchBarRoot = function SearchBarRoot2(_props) {
  return unsupported("SearchBar");
};
var SearchBar = Object.assign(SearchBarRoot, {
  LeadingIcon: function LeadingIcon(_props) {
    return unsupported("SearchBar.LeadingIcon");
  },
  TrailingIcon: function TrailingIcon(_props) {
    return unsupported("SearchBar.TrailingIcon");
  }
});
var DockedSearchBarRoot = function DockedSearchBarRoot2(_props) {
  return unsupported("DockedSearchBar");
};
var DockedSearchBar = Object.assign(DockedSearchBarRoot, {
  LeadingIcon: function LeadingIcon2(_props) {
    return unsupported("DockedSearchBar.LeadingIcon");
  },
  TrailingIcon: function TrailingIcon2(_props) {
    return unsupported("DockedSearchBar.TrailingIcon");
  }
});
function DropdownMenu(_props) {
  return unsupported("DropdownMenu");
}
function DropdownMenuItem(_props) {
  return unsupported("DropdownMenuItem");
}
function ExposedDropdownMenuBox(_props) {
  return unsupported("ExposedDropdownMenuBox");
}
function PullToRefreshBox(_props) {
  return unsupported("PullToRefreshBox");
}
function TooltipBox(_props) {
  return unsupported("TooltipBox");
}
function AnimatedVisibility(_props) {
  return unsupported("AnimatedVisibility");
}
function ProgressIndicator(_props) {
  return unsupported("ProgressIndicator");
}
function LinearProgressIndicator(_props) {
  return unsupported("LinearProgressIndicator");
}
function CircularProgressIndicator(_props) {
  return unsupported("CircularProgressIndicator");
}
function LinearWavyProgressIndicator(_props) {
  return unsupported("LinearWavyProgressIndicator");
}
function CircularWavyProgressIndicator(_props) {
  return unsupported("CircularWavyProgressIndicator");
}
function LoadingIndicator(_props) {
  return unsupported("LoadingIndicator");
}
function ContainedLoadingIndicator(_props) {
  return unsupported("ContainedLoadingIndicator");
}
function DatePicker(_props) {
  return unsupported("DatePicker");
}
function TimePicker(_props) {
  return unsupported("TimePicker");
}
function DatePickerDialog(_props) {
  return unsupported("DatePickerDialog");
}
function TimePickerDialog(_props) {
  return unsupported("TimePickerDialog");
}
function BasicAlertDialog(_props) {
  return unsupported("BasicAlertDialog");
}
function HorizontalCenteredHeroCarousel(_props) {
  return unsupported("HorizontalCenteredHeroCarousel");
}
function HorizontalMultiBrowseCarousel(_props) {
  return unsupported("HorizontalMultiBrowseCarousel");
}
function HorizontalUncontainedCarousel(_props) {
  return unsupported("HorizontalUncontainedCarousel");
}
function DateRangePicker(_props) {
  return unsupported("DateRangePicker");
}
function DateRangePickerDialog(_props) {
  return unsupported("DateRangePickerDialog");
}
function SyncSwitch(_props) {
  return unsupported("SyncSwitch");
}
var HorizontalFloatingToolbar = Object.assign(function(_props) {
  return unsupported("HorizontalFloatingToolbar");
}, {
  FloatingActionButton: function FloatingActionButton2(_props) {
    return unsupported("HorizontalFloatingToolbar.FloatingActionButton");
  }
});
var Shape = Object.fromEntries([
  "Star",
  "PillStar",
  "Pill",
  "Circle",
  "Rectangle",
  "Polygon",
  "RoundedCorner"
].map(function(name) {
  return [
    name,
    function(_props) {
      return unsupported(`Shape.${name}`);
    }
  ];
}));
var Compose = {
  BasicAlertDialog,
  HorizontalCenteredHeroCarousel,
  HorizontalMultiBrowseCarousel,
  HorizontalUncontainedCarousel,
  DateRangePicker,
  DateRangePickerDialog,
  HorizontalFloatingToolbar,
  Shape,
  SyncSwitch,
  Column,
  Row,
  Spacer,
  FlowRow,
  Box,
  Badge,
  BadgedBox,
  ListItem,
  Card,
  ElevatedCard,
  OutlinedCard,
  Surface,
  HorizontalDivider,
  VerticalDivider,
  FilterChip,
  AssistChip,
  InputChip,
  SuggestionChip,
  Text,
  Icon,
  Button,
  IconButton,
  FilledIconButton,
  FilledTonalIconButton,
  OutlinedIconButton,
  FloatingActionButton,
  SmallFloatingActionButton,
  LargeFloatingActionButton,
  ExtendedFloatingActionButton,
  ToggleButton,
  IconToggleButton,
  FilledIconToggleButton,
  OutlinedIconToggleButton,
  SingleChoiceSegmentedButtonRow,
  MultiChoiceSegmentedButtonRow,
  SegmentedButton,
  Switch,
  Checkbox,
  RadioButton,
  TextField,
  Slider,
  AlertDialog,
  Dialog,
  LazyColumn,
  LazyRow,
  Image,
  Snackbar,
  SnackbarHost,
  ModalBottomSheet,
  NavigationBar,
  NavigationBarItem,
  SearchBar,
  DockedSearchBar,
  DropdownMenu,
  DropdownMenuItem,
  ExposedDropdownMenuBox,
  PullToRefreshBox,
  TooltipBox,
  AnimatedVisibility,
  ProgressIndicator,
  LinearProgressIndicator,
  CircularProgressIndicator,
  LinearWavyProgressIndicator,
  CircularWavyProgressIndicator,
  LoadingIndicator,
  ContainedLoadingIndicator,
  DatePicker,
  TimePicker,
  DatePickerDialog,
  TimePickerDialog
};
//# sourceMappingURL=compose.js.map
